import { MfaFreshProofRequest } from '@tinct/core-api-models';
import { createConnectedInputHelpers } from '@tinct/web-form';
import { useFormContext } from 'react-hook-form';
import { MfaCodeInput } from './mfa-code-input';

const { ControlledPasswordInput } = createConnectedInputHelpers<MfaFreshProofRequest>();

type MfaFreshProofFieldsProps = {
  /** Offer a code as an alternative proof (social sign-in users may have no password). */
  allowCode: boolean;
};

/** The fields of a fresh-proof form, inside a `FormProvider`. Shows the form-level error too. */
export const MfaFreshProofFields = ({ allowCode }: MfaFreshProofFieldsProps) => {
  const { formState } = useFormContext<MfaFreshProofRequest>();
  const rootError = formState.errors.root?.message;

  return (
    <div className="flex flex-col gap-4">
      <ControlledPasswordInput name="currentPassword" label="Current password" />
      {allowCode && (
        <MfaCodeInput
          name="code"
          kind="any"
          label="Verification code"
          description="If you sign in with Google, LinkedIn or Microsoft and have no password, enter a code from your authenticator app or one of your recovery codes instead."
        />
      )}
      {rootError && (
        <p role="alert" className="text-sm text-destructive">
          {rootError}
        </p>
      )}
    </div>
  );
};
